import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { usePlanCardContext } from '../../context';
import * as Styled from './styles';
import * as SX from './sx';
import type { ScaleOnDemandTagProps as Props } from './types';

export const ScaleOnDemandTag = memo(({ className }: Props) => {
  const { currentPlan, selectedPlan, isPaid } = usePlanCardContext();
  if (currentPlan?.id === selectedPlan?.id || !isPaid) return null;

  return (
    <Styled.Wrapper
      className={classnames('ScaleOnDemandTag', className)}
      sx={SX.root}
      label="Scale on Demand"
      variant="outlined"
      shape="rounded"
      color="warning"
      size="small"
    />
  );
});

ScaleOnDemandTag.displayName = 'ScaleOnDemandTag';
